import { LazyLoadImage } from "react-lazy-load-image-component";
import "./styles.scss";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-7_WEB.jpg";
function SectionNine({ placeholderSrc }) {
  return (
    <div className="tw-bg-secondary">
      <div className="spacer h-[6rem]"></div>
      <div className="tw-relative -tw-secondary-gradient md:tw-px-8 tw-pb-4">
        <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] tw-block">
          7
        </div>
        <LazyLoadImage
          alt="Votive XXXXI -  Ernest Shaw"
          src={photo} // use normal <img> attributes as props
          placeholderSrc={placeholderSrc}
          
        />
      </div>
      <div className="tw-bg-secondary tw-px-8 tw-pb-4">
        <p className="tw-font-bold tw-italic tw-mb-0 tw-text-2xl">
          Votive XXXXII
        </p>
        <p className="tw-font-bold tw-italic tw-mb-4 tw-text-sm">
          Ernest Shaw
        </p>
        <p>
          Its shapes transforming as it rises, this giant piece by New York
          artist and former psychiatrist Ernest Shaw seems to mirror the
          precarious progression of human development as it stands sentinel over
          the HSC Campus, reminding viewers of their own travels through life
          and learning.
        </p>
      </div>
    </div>
  );
}

export default SectionNine;
